var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4658 27.9999H8.5939C3.90431 27.9999 0.0596924 24.2748 0.0596924 19.7309V8.22799C0.0596924 3.68413 3.90431 -0.0410156 8.5939 -0.0410156H20.4658C25.1554 -0.0410156 29 3.68413 29 8.22799V19.7309C29 24.2748 25.1554 27.9999 20.4658 27.9999ZM8.5939 2.12857C5.12952 2.12857 2.29886 4.87126 2.29886 8.22799V19.7309C2.29886 23.0876 5.12952 25.8303 8.5939 25.8303H20.4658C23.9302 25.8303 26.7608 23.0876 26.7608 19.7309V8.22799C26.7608 4.87126 23.9302 2.12857 20.4658 2.12857H8.5939Z",
    fill: "#446073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5513 23.7016C8.46715 23.7016 5.97449 21.2864 5.97449 18.2981C5.97449 15.3098 8.46715 12.8946 11.5513 12.8946C12.185 12.8946 12.6498 13.3858 12.6498 13.9589C12.6498 14.532 12.1428 15.0232 11.5513 15.0232C9.69236 15.0232 8.21366 16.456 8.21366 18.2571C8.21366 20.0583 9.69236 21.4911 11.5513 21.4911C13.4102 21.4911 14.8889 20.0583 14.8889 18.2571V5.40334C14.8889 4.87118 15.2692 4.42089 15.8184 4.33901C16.3676 4.25714 16.8746 4.54369 17.0436 5.07586C17.2549 5.68989 17.7618 6.59048 18.5646 7.32732C19.5363 8.18697 20.6347 8.63726 21.9022 8.63726C22.5359 8.63726 23.0007 9.12849 23.0007 9.70159C23.0007 10.2747 22.4937 10.7659 21.9022 10.7659C20.0855 10.7659 18.4378 10.1109 17.0859 8.92381V18.339C17.0859 21.3273 14.5932 23.7425 11.5091 23.7425L11.5513 23.7016Z",
    fill: "#446073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.018a1f6a2ee15a99d1e2cb97dd546ac6.svg";
export { ForwardRef as ReactComponent };